import request from "@/util/http";
/**
 * 
 */
export function save(data) {
	return request({
		url: '/marketing/shop/seckill_marketing/save',
		method: 'post',
		data: data,
	})
}

/**
 * 秒杀查询
 * @param {Object} query
 */
export function list(query) {
	return request({
		url: '/marketing/shop/seckill_marketing/list',
		method: 'get',
		params: query,
	})
}

// module.exports = {
// 	save,
// 	list,
// }
